import styled from "@emotion/styled";
import PropTypes from "prop-types";

import styles from "./Listing.style";

const ListingStyled = styled.div((props) => ({ ...styles(props) }));

const Listing = ({ children, className, ...props }) => (
    <ListingStyled className={className} {...props}>
        {children}
    </ListingStyled>
);

Listing.propTypes = {
    className: PropTypes.string,
};

Listing.defaultProps = {
    className: undefined,
};

export default Listing;
